import { Tag as AntdTag } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ActivityKind } from 'entities/TableCellActivity';

export type TagChangeEvent = {
  value: ActivityKind;
  checked: boolean;
};

type TagProps = {
  onChange: ({ value, checked }: TagChangeEvent) => void;
  value: ActivityKind;
  checked: boolean;
};

const Tag: React.FC<React.PropsWithChildren<TagProps>> = ({
  onChange,
  children,
  checked,
  value,
}) => {
  const handleChange = React.useCallback(
    (newValue: boolean) => {
      onChange({
        value,
        checked: newValue,
      });
    },
    [onChange, value]
  );

  return (
    <AntdTag.CheckableTag onChange={handleChange} checked={checked}>
      {children}
    </AntdTag.CheckableTag>
  );
};

export default observer(Tag);
